<template>
  <!-- <div v-show="visible" :class="['message-box', type]">
    <div class="inner">
      <header class="header">
        <h1 class="title">{{ title }}</h1>
        <span @click="handleAction('cancel')" class="close-btc ">x</span>
      </header>
      <div class="content">
        <slot>{{ message }}</slot>
      </div>
      <div class="bottom">
        <el-button @click="handleAction('cancel')">取消</el-button>
        <el-button @click="handleAction('confirm')">确认</el-button>
      </div>
    </div>
  </div> -->

  <div class="popup_big_box flex_package" v-if="visible">
    <div>
      <img v-if="type === 'success'" :src="require('@/assets/images/common/popup/success.png')" alt="" />
      <img v-else-if="type === 'error'" :src="require('@/assets/images/common/popup/error.png')" alt="" />
      <img v-else :src="require('@/assets/images/common/popup/warn.png')" alt="" />
      <h2>{{ title }}</h2>
      <p v-if="message"><span>*</span>{{ message }}<span>*</span></p>
      <div class="popup_btn">
        <el-button class="popup_button" type="primary" @click="handleAction('confirm')">确定</el-button>
        <el-button class="popup_button" @click="handleAction('cancel')" v-if="iscancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/*
  自定义样式信息弹框，待继续完善
*/
export default {
  name: 'tipsDialog',
  props: {
    title: {
      type: String,
      default: '标题',
    },
    message: {
      type: String | Object,
      default: '内容',
    },
    iscancel: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'warn',
      validator(value) {
        return [
          'primary',
          'success',
          'warn',
          'error'
        ].includes(value);
      }
    }
  },
  data() {
    return {
      action: '',
      visible: false,
      callback: null,
    };
  },
  methods: {
    getSafeClose() {
      const currentId = this.uid;
      console.log('currentId', currentId)
      return () => {
        this.$nextTick(() => {
          if (currentId === this.uid) this.doClose();
        });
      };
    },
    handleAction(action) {
      this.action = action;
      if (typeof this.beforeClose === 'function') {
        this.close = this.getSafeClose();
        this.beforeClose(action, this, this.close);
      } else {
        this.doClose();
      }
    },
    doClose() {
      if (!this.visible) return;
      this.visible = false;
      setTimeout(() => {
      //至于这里为什么模仿element要用settimeout包一下回调放入下一次事件循环执行
      //我认为应该是跟beforeClose有关 如果用户配置了beforeClose 也传入了callback //自己手动去调用第三个参数也就是this.close去关闭弹窗
      //然后关闭后面又写了其他执行代码即使有nexttick代码也应该晚于这些代码执行
      //不是settimeout的话 callback会先于其他代码执行
      //这时候 跟事件循环 回调函数应该的执行时机明显不符 这个不是太重要但迷惑了半天
        if (this.action) this.callback(this.action, this);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.popup_big_box {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;

  > div {
    min-width: 300px;
    min-height: 300px;
    width: auto;
    max-width: 500px;
    max-height: 600px;
    overflow: auto;
    background: #ffffff;
    box-shadow: 0px 10px 15px 0px rgba(45, 48, 67, 0.45);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 42px 42px 44px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 80px;
      height: 80px;
    }
    h2 {
      max-height: calc(100% - 200px);
      overflow: auto;
      margin-top: 41px;
      color: #2d3043;
      font-size: 16px;
    }
    p {
      margin-top: 22px;
      color: #2d3043;
      font-size: 14px;

      span {
        color: #ff780b;
      }
    }
    .popup_btn {
      margin-top: 42px;
      .popup_button{
        width: 100px;
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
}
</style>
